module.exports = __webpack_public_path__ + "img/gzhBg.f0dd6011.png";